import card from './card'
import list from './list'

export default {
    card,
    description: 'Once again this month, our trend analysts have identified the best practice trends for you.',
    list
}
